import backend from '@/i18n/pt/backend'

export default {
  ...backend,
  pages: {
    back: 'Voltar à página inicial',
    404: {
      title: 'Página não encontrada',
      description: 'A página a que pretende aceder não foi encontrada.',
      contact: 'Por favor verifique se o endereço está correto e contacte-nos caso tenha detetado alguma anomalia.'
    }
  },
  form: {
    error: 'Existem campos obrigatórios por preencher ou campos mal preenchidos.',
    logo_error: 'Tem de associar um logo à empresa',
    product_error: 'A proposta tem de ter pelo menos um produto selecionado.',
    alpha: 'O campo deve conter somente letras.',
    alpha_dash: 'O campo deve conter letras, números e traços.',
    alpha_num: 'O campo deve conter somente letras e números.',
    alpha_spaces: 'O só pode conter caracteres alfabéticos e espaços.',
    confirmed: 'A confirmação do campo deve ser igual.',
    email: 'O campo deve ser um email válido.',
    excluded: 'O campo deve ser um valor válido.',
    ext: 'O campo deve ser um ficheiro válido.',
    image: 'O campo deve ser uma imagem.',
    is: 'O valor inserido no campo não é válido.',
    oneOf: 'O campo deve ter um valor válido.',
    mimes: 'O campo deve ser um tipo de ficheiro válido.',
    numeric: 'O campo deve conter apenas números.',
    regex: 'O campo possui um formato inválido.',
    required: 'O campo é obrigatório.',
    required_if: 'O campo é obrigatório.',
    loading: 'A carregar os {data}...',
    sameAs: 'O campo deve ser igual ao campo {field}.',
    min_length: 'A password deve ter pelo menos {min} caracteres'
  },
  tabs: {
    general: 'Geral',
    companies: 'Empresas',
    contacts: 'Contactos',
    users: 'Utilizadores',
    proposal: 'Proposta',
    media: 'Media',
    data: 'Data',
    settings: 'Configurações',
    history: 'Histórico',
    import_pdf:'Importar PDF',
  },
  messages: {
    edit: 'Editar',
    edit_data: 'Editar Dados',
    edit_password: 'Editar Password',
    account_config: 'Configurações de Conta',
    permissions: 'Permissões',
    recovered: 'Item recuperado com sucesso',
    no_results: 'Sem Resultados',
    max_items: 'Só pode selecionar uma opção',
    deleted: 'Item apagado com sucesso',
    created: '{item} inserido com sucesso',
    created_plural: '{item} inseridos com sucesso',
    updated: '{item} atualizado com sucesso',
    unknown_error: 'Ocorreu um erro desconhecido',
    error: 'Ocorreu um erro',
    upload_error: 'É necessário preencher o campo ',
    upload_error_product_line: 'Produto da linha ',
    upload_error_line: ' Linha ',
    token_expired: 'O tempo da sessão de autenticação terminou',
    not_found_foreign: 'Não foi possível encontrar a opção escolhida como {field}.',
    item: 'Item',
    loading: 'A carregar...',
    unknown_upload_error: 'Ocorreu um erro ao carregar do seu CSV. Por favor, volte a inserir e tente novamente.',
    error_history: 'Ainda não existe histórico de propostas para este orçamento.',
    dont_have_permission: 'Não tem permissão para consultar estes dados.',
    remove_image: 'Remover Imagem',
    import_pdf: 'Atenção! O PDF selecionado irá substituir o que está atualmente associado a esta proposta.',
    external_approval: 'Como se trata de uma proposta com aprovação externa é da responsabilidade do utilizador atualizar o estado da proposta.'
  },
  actions: {
    submit: 'Submeter',
    filter: 'Filtrar',
    clear: 'Limpar',
    remove_selected: 'Apagar selecionados',
    import: 'Importar',
    pick_logo: 'Escolher Logo',
    pick_category: 'Escolher categoria',
    pick_type: 'Escolher tipo',
    pick_options: 'Escolher Opções',
    pick_term: 'Escolher Prazo',
    pick_file: 'Escolher Ficheiro',
    pick_signature: 'Escolher Assinatura',
    export: 'Exportar',
    save_send_approval: 'Guardar e Enviar para Aprovação',
    save_export: 'Guardar e Exportar',
    options: 'Opções',
    pick_contact: 'Escolher Contacto',
    pick_pages: 'Escolher página(s)',
    cancel: 'Cancelar',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    create: 'Criar Nova',
    new_copy:'Criar Cópia',
    pick_product: 'Escolher produto',
    pick_country: 'Escolher país',
    pick_district: 'Escolher distrito',
    pick_user: 'Escolher utilizador',
    pick_status: 'Escolher Estado',
    pick_coupon: 'Escolher cupão',
    pick_combination: 'Escolher artigo',
    pick_tax: 'Escolher imposto',
    pick_brand: 'Escolher marca',
    pick_attribute: 'Escolher atributo',
    pick_company: 'Escolher Empresa',
    pick_companies: 'Escolher Empresas',
    pick_users: 'Escolher Utilizadores',
    pick_role: 'Escolher Permissão',
    pick_client: 'Escolher Cliente',
    pick_workflow: 'Escolher Workflow',
    add: 'Adicionar',
    save: 'Guardar',
    back: 'Voltar à listagem',
    pick_group: 'Escolher Grupo',
    pick_classification: 'Escolher Classificação',
    pick_dosage_form: 'Escolher Forma Farmacêutica',
    pick_expirationDate: 'Escolher Data de Validade',
    pick_conditions: 'Escolher condições de fornecimento',
    pick_deadline: 'Escolher Prazo de Entrega'
  },
  login: {
    title: 'Bem-vindo!',
    message: 'Por favor autentique-se para aceder ao painel de administração.',
    remember: 'Memorizar acesso',
    forgot_password: 'Esqueceu-se da palavra-passe?',
    enter: 'Entrar',
    invalid: 'Os dados introduzidos não são válidos.',
    valid: 'Bem-vindo',
  },
  logout: {
    title: 'Desligar'
  },
  reset: {
    title: 'Esqueceu-se da palavra-passe?',
    reset_message: 'Por favor indique o seu email para receber instruções sobre como recuperar o acesso à sua conta.',
    reset_password: 'Redefinir palavra-passe',
    reset_sent: 'Foi enviada uma mensagem para o endereço indicado com instruções para definir a sua nova palavra-passe.',
    change_message: 'Por favor preencha os dados abaixo para alterar a palavra-passe.',
    welcome:'Bem vindo!',
    change_explanation: 'Como é a primeira vez que acede à plataforma, por questões de segurança, é necessário redefinir uma nova palavra-passe.',
    change_password: 'Alterar palavra-passe',
    password_changed: 'A palavra-passe foi alterada com sucesso.',
    new_password: 'Definir nova palavra-passe',
  },
  menu: {
    dashboard: 'Dashboard',
    products: 'Produtos',
    contacts: 'Contactos',
    companies: 'Empresas',
    clients: 'Clientes',
    users: 'Utilizadores',
    proposal: 'Proposta',
    taxes: 'Impostos',
    statuses: 'Estados',
    types: 'Tipos',
    budgets: 'Orçamentos',
    workflows: 'Workflows',
    groups: 'Grupos',
    account: 'Conta'
  },
  confirm: {
    are_you_sure: 'Tem a certeza?',
    yes: 'Sim',
    no: 'Não'
  },
  list: {
    filters: 'Filtros',
    tools: 'Ferramentas',
    page: 'Página',
    new: 'Novo',
    edit: 'Editar',
    save: 'Guardar',
    add: 'Adicionar',
    yes: 'Sim',
    no: 'Não',
    no_data: 'Não existem {data} para mostrar.',
  },
  field: {
    title: 'Título',
    content: 'Conteúdo',
    image: 'Imagem',
    name: 'Nome',
    nif: 'NIF',
    address: 'Morada',
    version: 'Versão',
    logo: 'Logo',
    date: 'Data',
    proposal_date: 'Data da Proposta',
    proposals_to_approve: 'Propostas para aprovar',
    proposals_sent: 'Propostas que aguardam aprovação',
    proposals_completed: 'Propostas concluídas',
    signature: 'Assinatura',
    other_fields: 'Outros Campos',
    financial_discount: 'Desconto Financeiro',
    commercial_discount: 'Desconto Comercial',
    total: 'Total',
    products: 'Produtos',
    product: 'Produto',
    notes: 'Notas',
    conditions: 'Condições de Fornecimento',
    subject: 'Assunto',
    responsible: 'Responsável',
    responsible_contact: 'Contacto do Responsável',
    proposal_value: 'Valor Total da Proposta',
    expiration_date: 'Prazo de Validade',
    deadline: 'Prazo de Entrega',
    payment_term: 'Prazo de Pagamento',
    email: 'Email',
    published_at: 'Data de publicação',
    discount: 'Desconto',
    position: 'Posição',
    batch: 'Lote',
    client_code: 'Código do Cliente',
    entity_code: 'Código Entidade',
    started_at: 'Data início',
    ended_at: 'Data fim',
    number_approvals: 'Número de Aprovações',
    type: 'Tipo',
    users: 'Utilizadores',
    order: 'Ordem',
    street: 'Rua',
    zip_code: 'Código postal',
    locality: 'Localidade',
    created_at: 'Data inserção',
    company: 'Empresa',
    status: 'Estado',
    phone: 'Telemóvel',
    permissions: 'Permissões',
    value: 'Valor',
    district: 'Distrito',
    companies: 'Empresas',
    zone: 'Zona',
    code: 'Código',
    reference: 'N. Referência',
    city: 'Cidade',
    county: 'Concelho',
    quantity: 'Quantidade Pedida (unid.)',
    quantity_package: 'Quantidade Pedida (caixa)',
    quantity_per_package: 'Número de Unidades por Caixa',
    observations: 'Observações',
    price: 'Preço',
    tax: 'Imposto',
    attribute: 'Atributo',
    rejection_reason: 'Motivo',
    description: 'Descrição',
    description_keyed: 'Descrição ({field})',
    aim_code: 'Código AIM',
    anf_code: 'Código ANF',
    sap_code: 'Código SAP',
    spms_code: 'Código SPMS',
    client: 'Cliente',
    clientContact: 'Contacto do Cliente',
    user: 'Utilizador',
    roles: 'Permissões',
    workflow: 'Workflow de Aprovação',
    commercial_name: 'Nome Comercial (DCI)',
    dosage: 'Dosagem',
    dosage_form: 'Forma Farmacêutica',
    presentation: 'Apresentação',
    conservation_conditions: 'Condições de Conservação',
    price_unit: 'Preço (unid.)',
    price_package: 'Preço (caixa)',
    classification: 'Classificação',
    authorization_date: 'Data de Autorização',
    is_marketed: 'Comercializado ?',
    marketing_date: 'Data de Comercialização',
    is_generic_drug: 'Genérico ?',
    license: 'Licença',
    taim: 'TAIM',
    department: 'Departamento',
    website: 'Website',
    country: 'País',
    group: 'Grupo',
    password: 'Palavra-passe',
    new_password: 'Nova palavra-passe',
    password_confirmation: 'Repetir palavra-passe',
    share_capital: 'Capital Social',
    register: 'Conservatória do Registo Comercial',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle_summary: 'Resumo',
  },
  history: {
    rejected: 'Rejeitado',
    approved: 'Aprovado',
    waiting_approval: 'Aguarda aprovação',
    motive: 'Motivo'
  },
  modals: {
    new_contact: 'Novo Contacto',
    add_product: 'Adicionar Produto',
    contact: 'Contacto'
  }
}
